import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './REVSHARE_Token_Economics_S.css';

const REVSHARE_Token_Economics_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Revenue Share Token Token Economics');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_TOKEN_ECONOMICS/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/REVSHARE_Token_Economics', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_${i}_SECTION`;
	  const headerId = `#REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_TOKEN_ECONOMICS/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/REVSHARE_Token_Economics',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [REVSHARE_TOKEN_ECONOMICS, setREVSHARE_TOKEN_ECONOMICS] = React.useState(null);
  const [REVSHARE_TOKEN_ECONOMICS_S, setREVSHARE_TOKEN_ECONOMICS_S] = React.useState(null);

  var Ids = [];
  for(var Ele in REVSHARE_TOKEN_ECONOMICS_S){
	  for(var Sec in REVSHARE_TOKEN_ECONOMICS_S[Ele]){
			if(Sec == "id")
				Ids.push(REVSHARE_TOKEN_ECONOMICS_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(REVSHARE_TOKEN_ECONOMICS_S[Ele]["status"]);
			else if(Array.isArray(REVSHARE_TOKEN_ECONOMICS_S[Ele][Sec]))
				  for(var Row in REVSHARE_TOKEN_ECONOMICS_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in REVSHARE_TOKEN_ECONOMICS_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_TOKEN_ECONOMICS`).then((response) => {
      setREVSHARE_TOKEN_ECONOMICS(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setREVSHARE_TOKEN_ECONOMICS_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!REVSHARE_TOKEN_ECONOMICS_S) return <div>Loading...</div>;

 const handleLastDataREVSHARE_TOKEN_ECONOMICS_S = async (data) => {
  };




  const handleAddREVSHARE_TOKEN_ECONOMICS_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_TOKEN_ECONOMICS_S', JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_TOKEN_ECONOMICS_S');
      setREVSHARE_TOKEN_ECONOMICS_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["1"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("1","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["1"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("1","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["1"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("1","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  

const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["1"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3"]=value;
	Form_Data_onChange("1","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  


const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["1"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4"]=value;
	Form_Data_onChange("1","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  


const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["1"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5"]=value;
	Form_Data_onChange("1","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  


const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["2"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0"]=value;
	Form_Data_onChange("2","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  

    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["2"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("2","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["2"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("2","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["2"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("2","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["2"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("2","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["2"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("2","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  

const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["3"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0"]=value;
	Form_Data_onChange("3","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  

    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["3"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("3","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["3"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("3","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["3"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("3","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["3"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("3","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  

const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["4"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0"]=value;
	Form_Data_onChange("4","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  

    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["4"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("4","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["4"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("4","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["4"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("4","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  

const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["4"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4"]=value;
	Form_Data_onChange("4","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  


const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["4"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5"]=value;
	Form_Data_onChange("4","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  


const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["5"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0"]=value;
	Form_Data_onChange("5","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  


const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["5"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1"]=value;
	Form_Data_onChange("5","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  

  
      
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["5"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2"]=value ? true : false; // optionally just use boolean
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("5","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  


  
      
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["5"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3"]=value ? true : false; // optionally just use boolean
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("5","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  


    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["6"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("6","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  

const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS));
	Temp_Data["9"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0"]=value;
	Form_Data_onChange("9","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS(Temp_Data);
	//handleAddREVSHARE_TOKEN_ECONOMICS(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS']);
  }; 
  

    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["9"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("9","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["9"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("9","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["9"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("9","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_TOKEN_ECONOMICS_S));
	Temp_Data["9"]["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4"]=value;
	//handleAddREVSHARE_TOKEN_ECONOMICS_S(Temp_Data,App_Data['REVSHARE_TOKEN_ECONOMICS_S']);
	Form_Data_onChange("9","REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4",value,Temp_Data);
 	//handleLastDataREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
    setREVSHARE_TOKEN_ECONOMICS_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = REVSHARE_TOKEN_ECONOMICS_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Revenue Share Token Token Economics')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`REVSHARE Token Economics ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0" type="text" className="form-control" placeholder="REVSHARE Token Economics ID"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter REVSHARE Token Economics ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1" type="text" className="form-control" placeholder="Offering ID"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2" type="text" className="form-control" placeholder="Token Class ID"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Token Class ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Economic Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3_Change} className="form-control" name="Token Economic Model"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Debt Interest">Debt Interest</option>
						  <option value="Hybrid">Hybrid</option>
						  <option value="Pre-Auction Conditional Pool">Pre-Auction Conditional Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Economic Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Ownership Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4_Change} className="form-control" name="Token Ownership Model"  >
						  <option value="No Direct Ownership / Economic Right Only">No Direct Ownership / Economic Right Only</option>
						  <option value="Revenue Participation Right">Revenue Participation Right</option>
						  <option value="Sale Proceeds Participation">Sale Proceeds Participation</option>
						  <option value="Equity Appreciation Participation">Equity Appreciation Participation</option>
						  <option value="Preferred Equity Interest">Preferred Equity Interest</option>
						  <option value="Common Equity Ownership Percentage">Common Equity Ownership Percentage</option>
						  <option value="Debt / Note Holder Claim">Debt / Note Holder Claim</option>
						  <option value="Hybrid Economic Rights">Hybrid Economic Rights</option>
						  <option value="Conditional Auction Pool Right">Conditional Auction Pool Right</option>
						  <option value="Post-Auction Asset Economic Right">Post-Auction Asset Economic Right</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Ownership Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5_Change} className="form-control" name="Distribution Source"  >
						  <option value="Net Rental Income / NOI">Net Rental Income / NOI</option>
						  <option value="Gross Revenue / Net Operating Revenue">Gross Revenue / Net Operating Revenue</option>
						  <option value="Asset Sale Proceeds">Asset Sale Proceeds</option>
						  <option value="NAV Appreciation / Exit Value">NAV Appreciation / Exit Value</option>
						  <option value="Preferred Return / Profit Waterfall">Preferred Return / Profit Waterfall</option>
						  <option value="Pro Rata Income and Exit Proceeds">Pro Rata Income and Exit Proceeds</option>
						  <option value="Interest and Principal Payments">Interest and Principal Payments</option>
						  <option value="Multiple Sources">Multiple Sources</option>
						  <option value="Conditional Auction Pool / Escrow Refund">Conditional Auction Pool / Escrow Refund</option>
						  <option value="Post-Auction Asset Proceeds">Post-Auction Asset Proceeds</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Ownership Component Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0_Change} className="form-control" name="Ownership Component Type"  >
						  <option value="Project Ownership">Project Ownership</option>
						  <option value="Building Ownership">Building Ownership</option>
						  <option value="Land Ownership">Land Ownership</option>
						  <option value="SPV Ownership">SPV Ownership</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Ownership Component Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Ownership Percentage Per Token`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1" type="text" className="form-control" placeholder="Ownership Percentage Per Token"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Ownership Percentage Per Token`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Total Project Ownership Percentage Represented`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2" type="text" className="form-control" placeholder="Total Project Ownership Percentage Represented"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Total Project Ownership Percentage Represented`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Building Ownership Percentage Represented`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3" type="text" className="form-control" placeholder="Building Ownership Percentage Represented"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Building Ownership Percentage Represented`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Land Ownership Percentage Represented`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4" type="text" className="form-control" placeholder="Land Ownership Percentage Represented"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Land Ownership Percentage Represented`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV Ownership Percentage Represented`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5" type="text" className="form-control" placeholder="SPV Ownership Percentage Represented"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV Ownership Percentage Represented`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Economic Component Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0_Change} className="form-control" name="Economic Component Type"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Fee">Fee</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Economic Component Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Rental Income Allocation Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1" type="text" className="form-control" placeholder="Rental Income Allocation Percentage"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Rental Income Allocation Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Sale Profit Allocation Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2" type="text" className="form-control" placeholder="Sale Profit Allocation Percentage"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Sale Profit Allocation Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Equity Appreciation Allocation Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3" type="text" className="form-control" placeholder="Equity Appreciation Allocation Percentage"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Equity Appreciation Allocation Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Revenue Share Allocation Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4" type="text" className="form-control" placeholder="Revenue Share Allocation Percentage"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Revenue Share Allocation Percentage`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Waterfall Component Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0_Change} className="form-control" name="Waterfall Component Type"  >
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Manager Promote">Manager Promote</option>
						  <option value="Investor Distribution">Investor Distribution</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Waterfall Component Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Debt Interest Rate`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1" type="text" className="form-control" placeholder="Debt Interest Rate"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Debt Interest Rate`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Preferred Return Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2" type="text" className="form-control" placeholder="Preferred Return Percentage"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Preferred Return Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Profit Split Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3" type="text" className="form-control" placeholder="Profit Split Percentage"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Profit Split Percentage`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Principal Repayment Priority`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4_Change} className="form-control" name="Principal Repayment Priority"  >
						  <option value="Senior">Senior</option>
						  <option value="Pari Passu">Pari Passu</option>
						  <option value="Subordinated">Subordinated</option>
						  <option value="At Maturity">At Maturity</option>
						  <option value="Amortizing">Amortizing</option>
						  <option value="Interest Only">Interest Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Principal Repayment Priority
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Waterfall Priority`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5_Change} className="form-control" name="Waterfall Priority"  >
						  <option value="Debt First">Debt First</option>
						  <option value="Preferred Return First">Preferred Return First</option>
						  <option value="Pro Rata">Pro Rata</option>
						  <option value="Manager Promote After Hurdle">Manager Promote After Hurdle</option>
						  <option value="Custom">Custom</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Waterfall Priority
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Frequency`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0_Change} className="form-control" name="Distribution Frequency"  >
						  <option value="Monthly">Monthly</option>
						  <option value="Quarterly">Quarterly</option>
						  <option value="Semiannual">Semiannual</option>
						  <option value="Annual">Annual</option>
						  <option value="At Exit">At Exit</option>
						  <option value="Event Driven">Event Driven</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Frequency
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Calculation Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1_Change} className="form-control" name="Calculation Method"  >
						  <option value="Manual">Manual</option>
						  <option value="Formula-Based">Formula-Based</option>
						  <option value="NAV-Based">NAV-Based</option>
						  <option value="Waterfall">Waterfall</option>
						  <option value="Third-Party Verified">Third-Party Verified</option>
						  <option value="Hybrid">Hybrid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Calculation Method
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`NAV Based`)} <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2_Change} 
					  checked={REVSHARE_TOKEN_ECONOMICS_S?.["5"]?.["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2"] === "true" || REVSHARE_TOKEN_ECONOMICS_S?.["5"]?.["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Investor Disclosure Required`)} <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3_Change} 
					  checked={REVSHARE_TOKEN_ECONOMICS_S?.["5"]?.["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3"] === "true" || REVSHARE_TOKEN_ECONOMICS_S?.["5"]?.["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Economic Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0" type="text" className="form-control" placeholder="Economic Notes"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4000ch' }}>
						 {t(`Enter Economic Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0"   onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`REVSHARE Token Economics ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Token Class ID`)}</th>
                        <th>{t(`Token Economic Model`)}</th>
                        <th>{t(`Token Ownership Model`)}</th>
                        <th>{t(`Distribution Source`)}</th>
                        <th>{t(`Ownership Component Type`)}</th>
                        <th>{t(`Ownership Percentage Per Token`)}</th>
                        <th>{t(`Total Project Ownership Percentage Represented`)}</th>
                        <th>{t(`Building Ownership Percentage Represented`)}</th>
                        <th>{t(`Land Ownership Percentage Represented`)}</th>
                        <th>{t(`SPV Ownership Percentage Represented`)}</th>
                        <th>{t(`Economic Component Type`)}</th>
                        <th>{t(`Rental Income Allocation Percentage`)}</th>
                        <th>{t(`Sale Profit Allocation Percentage`)}</th>
                        <th>{t(`Equity Appreciation Allocation Percentage`)}</th>
                        <th>{t(`Revenue Share Allocation Percentage`)}</th>
                        <th>{t(`Waterfall Component Type`)}</th>
                        <th>{t(`Debt Interest Rate`)}</th>
                        <th>{t(`Preferred Return Percentage`)}</th>
                        <th>{t(`Profit Split Percentage`)}</th>
                        <th>{t(`Principal Repayment Priority`)}</th>
                        <th>{t(`Waterfall Priority`)}</th>
                        <th>{t(`Distribution Frequency`)}</th>
                        <th>{t(`Calculation Method`)}</th>
                        <th>{t(`NAV Based`)}</th>
                        <th>{t(`Investor Disclosure Required`)}</th>
                        <th>{t(`Economic Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {REVSHARE_TOKEN_ECONOMICS_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_1"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_2"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_3"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_4"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_1_5"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_1"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_2"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_3"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_4"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_2_5"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_1"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_2"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_3"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_3_4"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_1"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_2"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_3"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_4"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_4_5"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_1"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_2"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_5_3"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_6_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_0"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_1"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_2"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_3"]} </td>
						<td>{e["REVENUE_SHARE_02_OFFERING_LEGAL_COMPLIANCE_READINESS_REVSHARE_TOKEN_ECONOMICS_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default REVSHARE_Token_Economics_S;  